//@ts-nocheck
import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  Link,
  useLocation,
  useMatch,
  useNavigate,
  useParams,
} from "react-router-dom";
import {
  BackIcon,
  BrandIcon,
  CalenderIcon,
  ChartPieIcon,
  ChevronDownIcon,
  CrossIcon,
  DocumentIcon,
  FilesIcon,
  HomeIcon,
  InboxIcon,
  MeetingIcon,
  MessageIcon,
  NotebookIcon,
  NoteIcon,
  ReviewIcon,
  RouteIcon,
  ScoreCardIcon,
  SquareCheckIcon,
  TeamDiscussionIcon,
  UsersIcon,
} from "../../components/icons/Icons";
import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";
import {
  Listbox,
  ListboxButton,
  ListboxOptions,
  ListboxOption,
  Switch,
  Transition,
} from "@headlessui/react";
import { fetchJobPipelineDetailsData } from "../../features/pipeline/pipelineSlice";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import {
  fetchApplicationByDetails,
  fetchApplicationByListData,
  fetchApplicationByListDataFilter,
  updateApplicationAiData,
  UpdateJobApplicationByList,
  UpdateJobApplicationByListForApplication,
} from "../../features/ApplicationData/ApplicationDataSlice";
import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  DialogTitle,
} from "@headlessui/react";
import { toast } from "sonner";

import { motion } from "framer-motion";
import ApplicationQuestionnaireSection from "../../components/jobApplicationDetails/Questionnaire/ApplicationQuestionnaireSection";
import QuestionSetDetails from "../../components/jobApplicationDetails/Questionnaire/QuestionSetDetails";
import MeetingSection from "../../components/jobApplicationDetails/ApplicationMeeting/MeetingSection";
import MeetingDetails from "../../components/jobApplicationDetails/ApplicationMeeting/MeetingDetails";
import { _baseRequest, COMMON } from "../../utils/baseApi";
import { tr } from "date-fns/locale";
import CandidateDetails from "../../components/jobApplicationDetails/CandidateDetails";
import CandidateReviewLayout from "../../components/jobApplicationDetails/candidateReview/CandidateReviewLayout";
import AppReviewDetails from "../../components/jobApplicationDetails/ApplicationAppReview/AppReviewDetails";
import Journey from "../../components/jobApplicationDetails/Journey";
import JobSkillScorecardEdit from "../../components/jobApplicationDetails/JobSkillScorecardEdit";
import JobSkillScorecard from "../../components/jobApplicationDetails/JobSkillScorecard";
import CandidateLayoutFilter from "../../components/jobApplicationDetails/CandidateLayoutFilter";
import JobScorecardsSection from "../../components/jobApplicationDetails/JobScorecardsSection";
import JobFilesSection from "../../components/jobApplicationDetails/JobFilesSection";
import JobNotesSection from "../../components/jobApplicationDetails/JobNotesSection";
import JobTeamDiscussion from "../../components/jobApplicationDetails/JobTeamDiscussion";
import JobMessageSection from "../../components/jobApplicationDetails/JobMessageSection";
import JobWorkplaceTypeListbox from "../../components/jobApplicationDetails/JobWorkplaceTypeListbox";
import JobEduLocationModal from "../../components/jobApplicationDetails/JobEduLocationModal";
import JobExperienceSection from "../../components/jobApplicationDetails/JobExperienceSection";
import JobResumeSection from "../../components/jobApplicationDetails/JobResumeSection";
import JobEducationSection from "../../components/jobApplicationDetails/JobEducationSection";
import AppReviewSection from "../../components/jobApplicationDetails/ApplicationAppReview/AppReviewSection";
import SkillsInput from "../../components/common/SkillsInput";

interface CandidateLayoutProps {
  children: React.ReactNode;
}

interface FilterOption {
  id: string;
  name: string;
  value: string;
}

function classNames(...classes: any) {
  return classes.filter(Boolean).join(" ");
}

function cn(...classes) {
  return classes.filter(Boolean).join(" ");
}

const CustomDropdown = ({
  label,
  value,
  onChange,
  options,
  name,
  placeholder = "Select...",
}) => {
  const selectedOption = options.find((opt) => opt.value === value);

  const handleChange = (newValue) => {
    onChange({
      target: {
        name: name,
        value: newValue,
      },
    });
  };

  return (
    <div className="grid gap-[6px]">
      {label && (
        <label className="wg-label inline-flex shrink-0 items-center gap-1 text-[14px] text-[#2f2f31] wg-antialiased leading-5">
          {label}
        </label>
      )}
      <Listbox value={value} onChange={handleChange}>
        <div className="relative">
          <Listbox.Button className="relative w-full cursor-pointer rounded-lg bg-white py-[5px] pl-3 pr-10 text-left border border-gray-200 focus:outline-none focus-visible:border-indigo-500 focus-visible:ring-2 focus-visible:ring-white/75 focus-visible:ring-offset-2">
            <span
              className={`block truncate text-[14px] ${!selectedOption ? "text-gray-400" : "text-gray-900"}`}
            >
              {selectedOption ? selectedOption.label : placeholder}
            </span>
            <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
              <ChevronDownIcon
                className="h-5 w-5 text-gray-400"
                aria-hidden="true"
              />
            </span>
          </Listbox.Button>
          <Transition
            as={React.Fragment}
            leave="transition ease-in duration-100"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Listbox.Options className="absolute overflow-auto h-[150px] z-10 mt-[9px] left-[0px] bg-white max-w-[100%] min-w-[100%] w-full rounded-lg border border-border bg-popover p-1 text-popover-foreground shadow-lg shadow-black/5 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 ">
              {options.map((option) => (
                <Listbox.Option
                  key={option.value}
                  value={option.value}
                  className={({ active, selected }) =>
                    `relative flex cursor-default select-none items-center gap-2 rounded-md px-2 py-1.5 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 ${active ? "bg-gray-200 text-[#1d2025]" : "text-gray-900"}`
                  }
                >
                  {({ selected }) => (
                    <span
                      className={`block truncate text-[14px] ${selected ? "font-medium" : "font-normal"}`}
                    >
                      {option.label}
                    </span>
                  )}
                </Listbox.Option>
              ))}
            </Listbox.Options>
          </Transition>
        </div>
      </Listbox>
    </div>
  );
};

// user

const useClickOutside1User = (handler) => {
  const ref = useRef(null);
  useEffect(() => {
    const listener = (event) => {
      // Do nothing if clicking ref's element or descendent elements
      if (!ref.current || ref.current.contains(event.target)) {
        return;
      }

      handler(event);
    };
    document.addEventListener("mousedown", listener);
    document.addEventListener("touchstart", listener);
    return () => {
      document.removeEventListener("mousedown", listener);
      document.removeEventListener("touchstart", listener);
    };
  }, [ref, handler]);

  return ref;
};

const UserAssignedDropdown = ({
  assignUserList,
  onUserSelect,
  currentlyAssignedUser,
}) => {
  const [searchTerm1, setSearchTerm1] = useState("");
  const [isDropdownOpen1, setIsDropdownOpen1] = useState(false);

  const dropdownRef = useClickOutside1User(() => {
    setIsDropdownOpen1(false);
    setSearchTerm1("");
  });

  // Memoized filtered users based on search term
  const filteredUsers = useMemo(() => {
    return assignUserList.filter((user) =>
      user.name.toLowerCase().includes(searchTerm1.toLowerCase()),
    );
  }, [assignUserList, searchTerm1]);

  const handleUserSelect = (user) => {
    onUserSelect(user);
    setIsDropdownOpen1(false);
    setSearchTerm1("");
  };

  // Handle unassign action
  const handleUnassign = () => {
    // Pass null to indicate unassign
    onUserSelect({ id: null });
    setIsDropdownOpen1(false);
    setSearchTerm1("");
  };

  const toggleDropdown = (e) => {
    // Prevent event from propagating to document
    e.stopPropagation();
    setIsDropdownOpen1(!isDropdownOpen1);
  };

  // Find current user object to display profile pic in button
  const currentUser = currentlyAssignedUser
    ? assignUserList.find((user) => user.name === currentlyAssignedUser)
    : null;

  const buttonBgColor = currentlyAssignedUser
    ? "inline-flex capitalize items-center rounded-md bg-gray-50 px-2 py-1 text-xs font-medium text-gray-600 ring-1 ring-inset ring-gray-500/10"
    : "inline-flex capitalize items-center h-[24px] rounded-md bg-gray-50 px-2 py-1 text-xs font-medium text-gray-600 border-dashed border border-gray-300";

  // const buttonText = currentlyAssignedUser ? `User: ${currentlyAssignedUser}` : 'Assign User';

  return (
    <div ref={dropdownRef} className="relative mt-">
      <span
        className="table-tooltip before:!bottom-[-35px] before:!left-[41px]"
        data-title="Assign user"
      >
        <button
          onClick={toggleDropdown}
          className={` w-full flex gap-x-2 items-center justify-start whitespace-nowrap rounded-lg text-sm font-medium transition-colors outline-offset-2 
            focus-visible:outline focus-visible:outline-2 focus-visible:outline-ring/70 disabled:pointer-events-none disabled:opacity-50 
             [&_svg]:pointer-events-none [&_svg]:shrink-0 border border-input bg-background shadow-sm shadow-black/5 hover:bg-accent hover:text-accent-foreground h-8 px-2  py-2`}
        >
          {currentUser?.profile_pic ? (
            <img
              src={`${process.env.REACT_APP_API_BASE_URL}/${currentUser?.profile_pic}`}
              alt={`${currentUser?.name || "Profile"}`}
              className="h-5 w-5 flex-none rounded-full ring-1 ring-gray-900/10"
            />
          ) : (
            currentUser?.name && (
              <span
                className="bg-[#a3a3a3] flex items-center justify-center h-5 w-5 flex-none rounded-full ring-1 ring-gray-900/10
                      text-white text-[12px] font-medium capitalize line-clamp-1"
              >
                {currentUser?.name?.charAt(0).toUpperCase()}
              </span>
            )
          )}
          <span className="block truncate text-[#1b1b1b] font-normal capitalize">
            {currentlyAssignedUser ? (
              currentlyAssignedUser
            ) : (
              <div className="flex items-center gap-x-2">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={24}
                  height={24}
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth={2}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="icon icon-tabler icons-tabler-outline icon-tabler-users-plus w-[1rem] h-[1rem] text-[#808080]"
                >
                  <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                  <path d="M5 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0" />
                  <path d="M3 21v-2a4 4 0 0 1 4 -4h4c.96 0 1.84 .338 2.53 .901" />
                  <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                  <path d="M16 19h6" />
                  <path d="M19 16v6" />
                </svg>
                Assign User
              </div>
            )}
          </span>
          <span className="pointer-events-none">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={24}
              height={24}
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
              className="icon icon-tabler icons-tabler-outline icon-tabler-chevron-down w-[1rem] h-[1rem] text-[#808080]"
            >
              <path stroke="none" d="M0 0h24v24H0z" fill="none" />
              <path d="M6 9l6 6l6 -6" />
            </svg>
          </span>
        </button>
      </span>

      {isDropdownOpen1 && (
        <div className="absolute z-10 mt-[9px] left-[-16px] top-[26px] bg-white max-w-[161.05px] min-w-[161.05px] w-full overflow-hidden rounded-lg border border-border bg-popover py-1 px-0 text-popover-foreground shadow-lg shadow-black/5 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 ">
          {/* <div className="p-1 border-b">
            <input
              type="text"
              placeholder="Search users..."
              value={searchTerm1}
              onChange={(e) => setSearchTerm1(e.target.value)}
              className="w-full px-2 py-0 border rounded text-[12px] focus:outline-none focus:ring-0 focus:ring-blue-500 border-none outline-none"
            />
          </div> */}
          <ul className="max-h-60 overflow-y-auto p-0">
            {currentlyAssignedUser && (
              <li
                onClick={handleUnassign}
                className="px-3 py-1.5 mx-2 hover:bg-gray-100 cursor-pointer text-[12px] leading-4 rounded-md flex items-center gap-2"
              >
                <span
                  className="bg-[#a3a3a3] flex items-center justify-center h-5 w-5 flex-none rounded-full ring-1 ring-gray-900/10
                       text-white text-[12px] font-medium capitalize line-clamp-1"
                >
                  U
                </span>
                <span className="font-normal block truncate text-[14px]">
                  Unassign
                </span>
              </li>
            )}
            {currentlyAssignedUser && <hr className="my-1 border-gray-200" />}
            {filteredUsers.length > 0 ? (
              filteredUsers.map((user) => (
                <li
                  key={user.id}
                  onClick={() => handleUserSelect(user)}
                  className="px-3 py-1.5 hover:bg-gray-100  mx-2 cursor-pointer text-[12px] leading-4 rounded-md flex items-center gap-2"
                >
                  {user.profile_pic ? (
                    <img
                      src={`${process.env.REACT_APP_API_BASE_URL}/${user.profile_pic}`}
                      alt={`${user.name || "Profile"}`}
                      className="h-5 w-5 flex-none rounded-full ring-1 ring-gray-900/10"
                    />
                  ) : (
                    <span
                      className="bg-[#a3a3a3] flex items-center justify-center h-5 w-5 flex-none rounded-full ring-1 ring-gray-900/10
                       text-white text-[12px] font-medium capitalize line-clamp-1"
                    >
                      {user.name?.charAt(0).toUpperCase()}
                    </span>
                  )}
                  <span className="font-normal block truncate text-[14px]">
                    {user.name}
                  </span>
                </li>
              ))
            ) : (
              <li className="px-3 py-0 text-gray-500 text-[12px]">
                No user found
              </li>
            )}
          </ul>
        </div>
      )}
    </div>
  );
};

const QuickViewResponse: React.FC<CandidateLayoutProps> = ({
  children,
  quickData,
}) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { baseId, jobId } = useParams<{ baseId: string; jobId: string }>();
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(true);
  const [isOpenHeader, setIsOpenHeader] = useState(true);
  const location = useLocation();
  const currentPath = location.pathname.split("/").pop() || "overview";
  const [pipelineStages, setPipelineStages] = useState([]); // Ensure it's an array
  const dispatch = useAppDispatch();
  const allStagesOption = {
    id: "all",
    stage_name: "All Stages",
    stage_colour: "#9ca3af",
    applications: null,
  };
  const [selectedFilter, setSelectedFilter] = useState(allStagesOption); // Include the id property
  const [selectedFilterHeader, setSelectedFilterHeader] = useState(null);
  const optionsWithAllStagesHeader = [...pipelineStages];

  const optionsWithAllStages = [allStagesOption, ...pipelineStages];
  const [applicationList, setApplicationList] = useState([]);
  const [loadingApplicationList, setLoadingApplicationList] = useState(false); // Loading state
  const [candidatesList, setCandidatesList] = useState([]);
  const [currentCandidate, setCurrentCandidate] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [hasNextPage, setHasNextPage] = useState(false);
  const [applicationDetails, setapplicationDetails] = useState("");
  const [locationName, setLocationName] = useState("");
  const [isOverviewOpen, setIsOverviewOpen] = useState(true);
  const [isSkillModalOpen, setIsSkillModalOpen] = useState(false);
  const [isSkillLoading, setIsSkillLoading] = useState(false);
  const [selectedSkills, setSelectedSkills] = useState([]);

  // New states for experience modal
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [workplaceType, setWorkplaceType] = useState("");
  const locations = useAppSelector((state) => state.location.locationDetails);
  const [loadingLocation, setLoadingLocation] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [isLoadingMore, setIsLoadingMore] = useState(false);
  const [conductReview, setConductReview] = useState(false);
  let applicationId = quickData?.id;

  // Form state for new experience
  const [newExperienceForm, setNewExperienceForm] = useState({
    company: "",
    designation: "",
    startDateMonth: "",
    startDateYear: "",
    endDateMonth: "",
    endDateYear: "",
    location: "",
    workplaceType: "",
    isCurrentJob: false,
    description: "",
  });
  // education modal
  const [isModalOpenEdu, setIsModalOpenEdu] = useState(false);
  const [isLoadingEdu, setIsLoadingEdu] = useState(false);
  const [workplaceTypeEdu, setWorkplaceTypeEdu] = useState("");
  const [loadingLocationEdu, setLoadingLocationEdu] = useState(false);
  const [selectedCountryEdu, setSelectedCountryEdu] = useState(null);

  // Form state for new experience
  const [newEducationForm, setNewEducationForm] = useState({
    course: "",
    university: "",
    start_month: "",
    start_year: "",
    end_month: "",
    end_year: "",
    location: "",
    branch: "",
    grade: "",
    description: "",
  });

  const [previousFilters, setPreviousFilters] = useState<string>("");
  const [isFilterLoading, setIsFilterLoading] = useState(false);
  const [isLoadingApp, setIsLoadingApp] = useState(false);
  const [pipelineStageDataUser, setPipelineStageDataUser] = useState([]);
  const [applicationResponse, setApplicationResponse] = useState(null);
  const [applicationResponseLoading, setApplicationResponseLoading] =
    useState(false);
  // Add states for inline questionnaire details
  const [showQuestionnaireDetails, setShowQuestionnaireDetails] =
    useState(false);
  const [currentQuestionnaireId, setCurrentQuestionnaireId] = useState(null);

  // Add states for inline scorecard details
  const [showMeetingDetails, setShowMeetingDetails] = useState(false);
  const [currentMeetingId, setCurrentMeetingId] = useState(null);

  // Add states for inline appreview details
  const [showAppReviewDetails, setShowAppReviewDetails] = useState(false);
  const [currentAppReviewId, setCurrentAppReviewId] = useState(null);

  // Extract skillId from URL path instead of using useParams
  const scorecardMatch = useMatch(
    `/${baseId}/job/${jobId}/app/${applicationId}/scorecards/:skillId/*`,
  );
  const skillId = scorecardMatch?.params?.skillId;
  const isEditMode = location.pathname.includes("/edit");

  // questionnaire
  const questionMatch = useMatch(
    `/${baseId}/job/${jobId}/app/${applicationId}/questionnaire/:questionnaireId/*`,
  );
  const QuestionsId = questionMatch?.params?.questionnaireId;

  // meeting
  const meetingMatch = useMatch(
    `/${baseId}/job/${jobId}/app/${applicationId}/meetings/:meetingId/*`,
  );
  const meetingId = meetingMatch?.params?.meetingId;

  // app review
  const appReviewMatch = useMatch(
    `/${baseId}/job/${jobId}/app/${applicationId}/appreview/:appreviewId/*`,
  );
  const appreviewId = appReviewMatch?.params?.appreviewId;

  // candidate review
  const candidateReviewMatch = useMatch(
    `/${baseId}/job/${jobId}/app/${applicationId}/appreview/${appreviewId}/conduct-review`,
  );
  const isConductReview = location.pathname.includes("conduct-review");

  //

  const candidateReviewMatch1 = useMatch(
    `/${baseId}/job/${jobId}/app/${applicationId}/appreview/${appreviewId}/conduct-review/:conductReviewId/*`,
  );
  const appreviewId1 = candidateReviewMatch1?.params?.conductReviewId;

  useEffect(() => {
    let data = applicationDetails?.application?.stage_id;
    if (baseId) {
      const fetchJob = async () => {
        const storedBase = localStorage.getItem("jobPipelineStageData");
        if (storedBase) {
          const parsedData = JSON.parse(storedBase);

          if (parsedData && parsedData.stages) {
            setPipelineStages(parsedData.stages);
            setSelectedFilterHeader(
              parsedData.stages.find((stage) => stage.id == data),
            ); // Set stage based on ID or default to the first stage
          }
        }
      };
      fetchJob();
    }
  }, [baseId, jobId, applicationDetails]); // Ensure effect runs only when baseId/jobId changes

  useEffect(() => {
    if (currentPath === "overview") {
      setIsOverviewOpen(true);
    } else {
      setIsOverviewOpen(false);
    }
  }, [currentPath]);

  // Generate nav items with dynamic routing
  const generateNavItems = (appId: string) => [
    {
      name: "Overview",
      to: `/${baseId}/job/${jobId}/app/${appId}/overview`,
      icon: BrandIcon,
      current: currentPath === "overview",
    },
    {
      name: "Resume",
      to: `/${baseId}/job/${jobId}/app/${appId}/resume`,
      icon: DocumentIcon,
      current: currentPath === "resume",
    },
    {
      name: "Message",
      to: `/${baseId}/job/${jobId}/app/${appId}/message`,
      icon: MessageIcon,
      current: currentPath === "message",
    },
    {
      name: "Files",
      to: `/${baseId}/job/${jobId}/app/${appId}/files`,
      icon: FilesIcon,
      current: currentPath === "files",
    },
    {
      name: "Team Discussion",
      to: `/${baseId}/job/${jobId}/app/${appId}/team-discussion`,
      icon: TeamDiscussionIcon,
      current: currentPath === "team-discussion",
    },
    {
      name: "Notes",
      to: `/${baseId}/job/${jobId}/app/${appId}/notes`,
      icon: NoteIcon,
      current: currentPath === "notes",
    },
    // {
    //   name: 'ScoreCards',
    //   to: `/${baseId}/job/${jobId}/app/${appId}/scorecards`,
    //   icon: ScoreCardIcon,
    //   current: currentPath === 'scorecards'
    // },
    {
      name: "Questionnaire",
      to: `/${baseId}/job/${jobId}/app/${appId}/questionnaire`,
      icon: NotebookIcon,
      current: currentPath === "questionnaire",
    },
    {
      name: "Meetings",
      to: `/${baseId}/job/${jobId}/app/${appId}/meetings`,
      icon: CalenderIcon,
      current: currentPath === "meetings",
    },
    {
      name: "App Review",
      to: `/${baseId}/job/${jobId}/app/${appId}/appreview`,
      icon: ReviewIcon,
      current: currentPath === "appreview",
    },
    {
      name: "Journey",
      to: `/${baseId}/job/${jobId}/app/${appId}/journey`,
      icon: RouteIcon,
      current: currentPath === "journey",
    },
  ];

  const navItems = generateNavItems(applicationId || "3443");
  const isScoreCardDetail = currentPath.includes("scorecards/");

  // Function to get badge styles based on rating value
  const getRatingBadgeStyles = (rating: any) => {
    if (!rating)
      return {
        bg: "bg-gray-50",
        text: "text-gray-700",
        ring: "ring-gray-700/10",
      };

    const ratingValue = parseFloat(rating);

    if (ratingValue === 5) {
      // Strong Yes: Green
      return {
        bg: "bg-green-50",
        text: "text-green-700",
        ring: "ring-green-700/10",
      };
    } else if (ratingValue === 4) {
      // Yes: Light Green
      return {
        bg: "bg-emerald-50",
        text: "text-emerald-700",
        ring: "ring-emerald-700/10",
      };
    } else if (ratingValue === 3) {
      // Neutral: Blue
      return {
        bg: "bg-blue-50",
        text: "text-blue-700",
        ring: "ring-blue-700/10",
      };
    } else if (ratingValue === 2) {
      // No: Orange
      return {
        bg: "bg-orange-50",
        text: "text-orange-700",
        ring: "ring-orange-700/10",
      };
    } else if (ratingValue === 1) {
      // Strong No: Red
      return {
        bg: "bg-red-50",
        text: "text-red-700",
        ring: "ring-red-700/10",
      };
    } else {
      // Default style for any other values
      return {
        bg: "bg-gray-50",
        text: "text-gray-700",
        ring: "ring-gray-700/10",
      };
    }
  };

  const getRatingLabel = (rating: any) => {
    if (!rating) return null;

    const ratingValue = parseFloat(rating);

    if (ratingValue === 5) return "Strong Yes";
    if (ratingValue === 4) return "Yes";
    if (ratingValue === 3) return "Neutral";
    if (ratingValue === 2) return "No";
    if (ratingValue === 1) return "Strong No";

    return null;
  };

  const getSkillScaleBadgeStyles = (scale: any) => {
    // Parse the scale value to ensure it's a number
    const scaleValue = parseFloat(scale);

    // Set badge styles based on ranges
    if (scaleValue >= 3.5 && scaleValue <= 4.0) {
      // Expert: Green
      return {
        bg: "bg-green-50",
        text: "text-green-700",
        ring: "ring-green-700/10",
      };
    } else if (scaleValue >= 1.5 && scaleValue <= 3.4) {
      // Proficient: Blue
      return {
        bg: "bg-blue-50",
        text: "text-blue-700",
        ring: "ring-blue-700/10",
      };
    } else if (scaleValue >= 0.5 && scaleValue <= 1.4) {
      // Competent: Yellow
      return {
        bg: "bg-yellow-50",
        text: "text-yellow-700",
        ring: "ring-yellow-700/10",
      };
    } else if (scaleValue >= -1.5 && scaleValue <= 0.4) {
      // Limited: Orange
      return {
        bg: "bg-gray-50",
        text: "text-gray-700",
        ring: "ring-gray-700/10",
      };
    } else if (scaleValue >= -2.0 && scaleValue <= -1.6) {
      // Inadequate: Red
      return {
        bg: "bg-red-50",
        text: "text-red-700",
        ring: "ring-red-700/10",
      };
    } else {
      // Default style for any other values
      return {
        bg: "bg-gray-50",
        text: "text-gray-700",
        ring: "ring-gray-700/10",
      };
    }
  };

  useEffect(() => {
    if (baseId) {
      const fetchJob = async () => {
        const storedBase = localStorage.getItem("jobPipelineStageData");
        if (storedBase) {
          const parsedData = JSON.parse(storedBase);
          if (parsedData && parsedData.stages) {
            setPipelineStages(parsedData.stages);
          }
        } else {
          try {
            // if (jobId) {
            const res = await dispatch(
              fetchJobPipelineDetailsData({
                baseId: Number(baseId),
                JobId: jobId,
              }),
            ).unwrap();
            if (res && res.data) {
              setPipelineStages(res?.data?.stages);
              // }
            }
          } catch (error) {
            console.error("Error fetching base member details:", error);
          }
        }
      };
      fetchJob();
    }
  }, [baseId, dispatch]);

  // Helper function to parse date strings
  const parseDate = (dateStr) => {
    return new Date(dateStr);
  };

  // Helper function to format dates as YYYY-MM-DD
  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  // Helper function to get key prefix
  const getKeyPrefix = (filterType) => {
    switch (filterType) {
      case "Department":
        return "department_id";
      case "member":
        return "external";
      case "status":
        return "doc_status";
      case "subStatus":
        return "doc_sub_status";
      case "tags":
        return "doc_tag";
      case "priority":
        return "item_priority";
      case "internal":
        return "internal";
      case "Created at":
        return "submitted_from";
      case "Updated at":
        return "updated_from";
      default:
        return filterType.toLowerCase();
    }
  };

  useEffect(() => {
    const activeFiltersJobApplication = JSON.parse(
      localStorage.getItem("activeFiltersJobApplication") || "{}",
    );

    const stageId =
      activeFiltersJobApplication?.Stages?.length > 0
        ? activeFiltersJobApplication.Stages[0].id
        : "";

    if (stageId) {
      const stage = pipelineStages.find((stage) => stage.id === stageId);
      if (stage) {
        setSelectedFilter(stage);
      }
    } else {
      setSelectedFilter(allStagesOption);
    }
  }, [pipelineStages]);

  // applicationDetailsApi
  useEffect(() => {
    if (applicationId) {
      const fetchJob = async () => {
        setIsLoadingApp(true);
        try {
          const res = await dispatch(
            fetchApplicationByDetails({
              baseId: Number(baseId),
              jobId: jobId,
              applicationId: applicationId,
            }),
          ).unwrap();
          if (res.status === 200) {
            setapplicationDetails(res?.data);
          }
        } catch (error) {
          console.error("Error fetching base member details:", error);
        } finally {
          setIsLoadingApp(false);
        }
      };
      fetchJob();
    }
  }, [applicationId, dispatch, location.pathname]);

  useEffect(() => {
    if (applicationDetails && applicationDetails.job) {
      // Split location IDs if they can be multiple
      const locationIds = applicationDetails.job.job_location
        ? applicationDetails.job.job_location.split(",").map((id) => id.trim())
        : [];

      const baseLocationData = localStorage.getItem("baseLocationData")
        ? JSON.parse(localStorage.getItem("baseLocationData"))
        : { data: [] };

      // Find all matching locations
      const locationMatches = baseLocationData.data.filter((loc) =>
        locationIds.includes(loc.id),
      );

      // Set location names (joining if multiple)
      if (locationMatches.length > 0) {
        const locationNames = locationMatches.map(
          (match) => match.location_name,
        );
        setLocationName(locationNames.join(", "));
      } else {
        setLocationName("Location not found");
      }
    }
  }, [applicationDetails]);

  // New experience modal
  const handleAddExperience = () => {
    // Reset form when opening modal
    setNewExperienceForm({
      company: "",
      designation: "",
      startDateMonth: "",
      startDateYear: "",
      endDateMonth: "",
      endDateYear: "",
      location: "",
      workplaceType: "",
      isCurrentJob: false,
      description: "",
    });
    setWorkplaceType("");
    setSelectedCountry(null);
    setIsModalOpen(true);
  };

  const handleWorkplaceTypeChange = (value) => {
    setWorkplaceType(value);
    setNewExperienceForm((prev) => ({
      ...prev,
      workplaceType: value,
    }));
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setNewExperienceForm((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleLocationChange = (item) => {
    setSelectedCountry(item);
    setNewExperienceForm((prev) => ({
      ...prev,
      location: item.locationName,
    }));
  };

  const parseWorkExperience = (workString) => {
    try {
      const parsedData = JSON.parse(workString);

      return {
        ...parsedData,
        work_experience:
          parsedData.work_experience?.filter((work) => work !== null) || [],
      };
    } catch (e) {
      console.error("Error parsing work experience data:", e);
      return { work_experience: [] };
    }
  };

  const handleSubmit = async () => {
    setIsLoading(true);
    try {
      if (
        !newExperienceForm.company ||
        newExperienceForm.company.trim() === ""
      ) {
        toast.error("Company is required");
        setIsLoading(false);
        return;
      }
      if (
        !newExperienceForm.designation ||
        newExperienceForm.designation.trim() === ""
      ) {
        toast.error("Designation is required");
        setIsLoading(false);
        return;
      }
      // Parse existing work experience or create new structure
      const existingWorkExperience = applicationDetails.application?.app_work
        ? parseWorkExperience(applicationDetails.application.app_work)
        : { work_experience: [] };

      // Create new work experience entry
      const newWorkExperience = {
        company: newExperienceForm.company,
        designation: newExperienceForm.designation,
        startDateMonth: newExperienceForm.startDateMonth,
        startDateYear: newExperienceForm.startDateYear,
        endDateMonth: newExperienceForm.endDateMonth,
        endDateYear: newExperienceForm.endDateYear,
        location: newExperienceForm.location,
        workplace_type: newExperienceForm.workplaceType,
        isCurrentJob: newExperienceForm.isCurrentJob.toString(),
        description: newExperienceForm.description,
      };

      // Add new experience to the array
      const updatedWorkExperience = {
        ...existingWorkExperience,
        work_experience: [
          ...existingWorkExperience.work_experience,
          newWorkExperience,
        ],
      };

      const payload = {
        baseId,
        applicationId,
        app_work: JSON.stringify(updatedWorkExperience),
      };

      const response = await dispatch(
        UpdateJobApplicationByListForApplication(payload),
      ).unwrap();

      if (response.status === 200) {
        toast.success("Work experience added successfully");
        const res = await dispatch(
          fetchApplicationByDetails({
            baseId: Number(baseId),
            jobId: jobId,
            applicationId: applicationId,
          }),
        ).unwrap();

        if (res.status === 200) {
          setapplicationDetails(res?.data);
        }
        setIsModalOpen(false);
      }
    } catch (error) {
      console.error("Failed to add work experience:", error);
    } finally {
      setIsLoading(false);
    }
  };

  // Month options
  const months = [
    { value: "01", label: "January" },
    { value: "02", label: "February" },
    { value: "03", label: "March" },
    { value: "04", label: "April" },
    { value: "05", label: "May" },
    { value: "06", label: "June" },
    { value: "07", label: "July" },
    { value: "08", label: "August" },
    { value: "09", label: "September" },
    { value: "10", label: "October" },
    { value: "11", label: "November" },
    { value: "12", label: "December" },
  ];

  // Year options
  const years = Array.from({ length: 30 }, (_, i) => {
    const year = (2025 - i).toString();
    return { value: year, label: year };
  });

  // New education modal
  const handleAddEducation = () => {
    // Reset form when opening modal
    setNewEducationForm({
      course: "",
      university: "",
      start_month: "",
      start_year: "",
      end_month: "",
      end_year: "",
      location: "",
      branch: "",
      grade: "",
      description: "",
    });
    setSelectedCountryEdu(null);
    setIsModalOpenEdu(true);
  };

  const handleInputChangeEducation = (e) => {
    const { name, value } = e.target;
    setNewEducationForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleLocationChangeEdu = (item) => {
    setSelectedCountryEdu(item);
    setNewEducationForm((prev) => ({
      ...prev,
      location: item.locationName,
    }));
  };

  const parseEducation = (eduString) => {
    try {
      const parsedData = JSON.parse(eduString);
      return {
        ...parsedData,
        education_details:
          parsedData.education_details?.filter((edu) => edu !== null) || [],
      };
    } catch (e) {
      console.error("Error parsing education data:", e);
      return { education_details: [] };
    }
  };

  const handleSubmitEdution = async () => {
    setIsLoadingEdu(true);
    try {
      const exitingEducation = applicationDetails.application?.app_education
        ? parseEducation(applicationDetails.application.app_education)
        : { education_details: [] };

      // Create new education entry
      const newEducation = {
        course: newEducationForm.course,
        university: newEducationForm.university,
        start_month: newEducationForm.start_month,
        start_year: newEducationForm.start_year,
        end_month: newEducationForm.end_month,
        end_year: newEducationForm.end_year,
        location: newEducationForm.location,
        branch: newEducationForm.branch,
        grade: newEducationForm.grade,
        description: newEducationForm.description,
      };

      // Add new education to the array
      const updatedEducation = {
        ...exitingEducation,
        education_details: [
          ...exitingEducation.education_details,
          newEducation,
        ],
      };

      const payload = {
        baseId,
        applicationId,
        app_education: JSON.stringify(updatedEducation),
      };

      const response = await dispatch(
        UpdateJobApplicationByListForApplication(payload),
      ).unwrap();

      if (response.status === 200) {
        toast.success("Education added successfully");
        const res = await dispatch(
          fetchApplicationByDetails({
            baseId: Number(baseId),
            jobId: jobId,
            applicationId: applicationId,
          }),
        ).unwrap();

        if (res.status === 200) {
          setapplicationDetails(res?.data);
        }
        setIsModalOpenEdu(false);
      }
    } catch (error) {
      console.error("Failed to add education:", error);
    } finally {
      setIsLoadingEdu(false);
    }
  };

  // Month options
  const monthsEdu = [
    { value: "01", label: "January" },
    { value: "02", label: "February" },
    { value: "03", label: "March" },
    { value: "04", label: "April" },
    { value: "05", label: "May" },
    { value: "06", label: "June" },
    { value: "07", label: "July" },
    { value: "08", label: "August" },
    { value: "09", label: "September" },
    { value: "10", label: "October" },
    { value: "11", label: "November" },
    { value: "12", label: "December" },
  ];

  const currentCandidateData = applicationList.find(
    (candidate) => candidate.id === applicationId,
  );
  const currentIndexNo = currentCandidateData
    ? currentCandidateData.index_no
    : null;

  const [aiRun, setAiRun] = useState(false);
  const [saveAiRun, setSaveAiRun] = useState("");

  const handleClickAiRun = async () => {
    setAiRun(true);

    try {
      // Only send the parameters expected by the thunk
      const resultAction = await dispatch(
        updateApplicationAiData({
          baseId,
          appId: applicationId,
        }),
      );

      // Check if the action was fulfilled (not rejected)
      if (updateApplicationAiData.fulfilled.match(resultAction)) {
        toast.success("AI Run successfully!");
        setSaveAiRun(resultAction.payload);
      } else if (updateApplicationAiData.rejected.match(resultAction)) {
        // Handle the rejected action
        toast.error(resultAction.payload || "Failed to run AI");
      }
    } catch (error) {
      toast.error("Failed to run AI");
    } finally {
      setAiRun(false);
    }
  };

  const handleLoadPrev = async () => {
    try {
      if (!currentCandidateData) return;
      const prevIndexNo = currentCandidateData.index_no - 1;
      if (prevIndexNo < 0) return; // No previous candidate

      const res = await dispatch(
        fetchApplicationByListData({
          baseId,
          jobId,
          page: prevIndexNo,
          limit: 1,
        }),
      ).unwrap();
      if (res.status === 200 && res.data.jobApplication.length > 0) {
        const prevCandidate = res.data.jobApplication[0];

        // setApplicationList([prevCandidate]); // Update the list with the previous candidate
        navigate(`/${baseId}/job/${jobId}/app/${prevCandidate.id}/overview`);
      }
    } catch (error) {
      console.error("Error fetching previous candidate:", error);
    }
  };

  const handleLoadNext = async () => {
    try {
      const currentCandidate = applicationList.find(
        (candidate) => candidate.id === applicationId,
      );
      if (!currentCandidate) return;

      const nextIndexNo = currentCandidate.index_no + 1;
      const res = await dispatch(
        fetchApplicationByListData({
          baseId,
          jobId,
          page: nextIndexNo,
          limit: 1,
        }),
      ).unwrap();
      if (res.status === 200 && res.data.jobApplication.length > 0) {
        const nextCandidate = res.data.jobApplication[0];
        // setApplicationList([nextCandidate]); // Update the list with the next candidate
        navigate(`/${baseId}/job/${jobId}/app/${nextCandidate.id}/overview`);
      }
    } catch (error) {
      console.error("Error fetching next candidate:", error);
    }
  };

  const [isOpenFilter, setIsOpenFilter] = useState(false);

  const handleFilterClick = (e: React.MouseEvent) => {
    e.stopPropagation(); // Prevent dropdown
    setIsOpenFilter(!isOpenFilter);
  };

  const renderFormattedSummary = (summary) => {
    try {
      // Try to parse the summary as JSON
      const parsed = JSON.parse(summary);

      return (
        <div className="space-y-3">
          {parsed.highlight && (
            <div>
              <p className="font-medium mb-1">Highlight:</p>
              <ul className="list-disc pl-5">
                {Array.isArray(parsed.highlight) ? (
                  parsed.highlight.map((item, index) => (
                    <li key={index}>{item}</li>
                  ))
                ) : (
                  <li>{parsed.highlight}</li>
                )}
              </ul>
            </div>
          )}

          {parsed.strengths && (
            <div>
              <p className="font-medium mb-1">Strengths:</p>
              <ul className="list-disc pl-5">
                {parsed.strengths.map((item, index) => (
                  <li key={index}>{item}</li>
                ))}
              </ul>
            </div>
          )}

          {parsed.weaknesses && (
            <div>
              <p className="font-medium mb-1">Weaknesses:</p>
              <ul className="list-disc pl-5">
                {parsed.weaknesses.map((item, index) => (
                  <li key={index}>{item}</li>
                ))}
              </ul>
            </div>
          )}
        </div>
      );
    } catch (e) {
      // If it's not JSON, return the raw text
      return <p>{summary}</p>;
    }
  };

  const styles1 = getRatingBadgeStyles(
    applicationDetails?.application?.ai_rating,
  );
  const styles = getSkillScaleBadgeStyles(
    applicationDetails?.application?.user_rating,
  );

  // Add this useEffect to populate assignUserList from localStorage with name and profile info
  useEffect(() => {
    const baseMembersDetailsString = localStorage.getItem(
      "jobByHiringTeamMembers",
    );

    if (baseMembersDetailsString) {
      const hiringTeamMembers = JSON.parse(baseMembersDetailsString) || [];

      // Map through hiring team members and find matching baseMembers to get name and profile_pic
      const userList = hiringTeamMembers
        .map((member) => {
          // Find the matching user in baseMembers

          // Return combined data
          return {
            id: member.user_id,
            name: member?.name || "Unknown User",
            profile_pic: member?.profile_pic || null,
          };
        })
        .filter((user) => user.name !== "Unknown User"); // Optional: filter out users without matching names

      setPipelineStageDataUser(userList);
    }
  }, []);

  const handleAssignSelect1USer = async (user, id) => {
    const payload = {
      baseId,
      applicationId,
      assign_to: user.id,
    };

    const response = await dispatch(
      UpdateJobApplicationByListForApplication(payload),
    ).unwrap();
    if (response.status === 200) {
      const res = await dispatch(
        fetchApplicationByDetails({
          baseId: Number(baseId),
          jobId: jobId,
          applicationId: applicationId,
        }),
      ).unwrap();
      if (res.status === 200) {
        setapplicationDetails(res?.data);
      }
      toast.success("User assigned successfully!");
    } else {
      toast.error("Failed to assign user.");
    }
  };

  let findUser =
    applicationDetails?.application?.assign_to &&
    pipelineStageDataUser.find(
      (user) => user.id === applicationDetails?.application?.assign_to,
    );

  // aplication responses
  useEffect(() => {
    const fetchInitialData = async () => {
      let fullUrl = `${COMMON.apiBaseUrl()}/v1/${baseId}/${jobId}/${applicationId}/applicationAnswers.list`;

      try {
        setApplicationResponseLoading(true);
        const response = await _baseRequest(fullUrl, "GET");

        if (response.status === 200) {
          setApplicationResponse(response?.data);
        }
      } catch (error) {
        console.error("Error fetching initial data:", error);
      } finally {
        setApplicationResponseLoading(false);
      }
    };

    if (applicationId) {
      fetchInitialData();
    }
  }, [applicationId]);

  const [activeTab, setActiveTab] = useState("overview");

  // Update the handleChangeView function
  const handleChangeView = (e) => {
    // Get the button that was clicked
    const clickedButton = e.currentTarget;

    // Find the index of the clicked item in the navItems array
    const navItemIndex = Array.from(
      clickedButton.parentElement.parentElement.children,
    ).indexOf(clickedButton.parentElement);

    // Get the corresponding navigation item
    const selectedNavItem = navItems[navItemIndex];
    // Reset questionnaire details view when changing tabs
    setShowQuestionnaireDetails(false);
    setShowMeetingDetails(false);
    setShowAppReviewDetails(false);

    // Set the active tab based on the navigation item name
    if (selectedNavItem) {
      setActiveTab(selectedNavItem.name.toLowerCase().replace(" ", "-"));
    }
  };

  // Custom handler for questionnaire action
  const handleQuestionnaireAction = (id) => {
    setCurrentQuestionnaireId(id);
    setShowQuestionnaireDetails(true);
  };

  // Custom handler for questionnaire action
  const handleMeetingsAction = (id) => {
    setCurrentMeetingId(id);
    setShowMeetingDetails(true);
  };

  const handleAppReviewAction = (id) => {
    setCurrentAppReviewId(id);
    setShowAppReviewDetails(true);
  };

  const handleAddSkills = () => {
    const parsedSkills = applicationDetails?.application?.skills
      ? JSON.parse(applicationDetails.application.skills).skills
      : [];

    setSelectedSkills(parsedSkills); // this ensures SkillsInput receives correct data
    setIsSkillModalOpen(true);
  };

  const handleSkillsChange = (skills) => {
    setSelectedSkills(skills);
  };

  const handleSubmitSkills = async () => {
    setIsSkillLoading(true);

    if (!selectedSkills || selectedSkills.length === 0) {
      toast.error("Please select at least one skill.");
      setIsSkillLoading(false);
      return;
    }

    try {
      const updatedSkills = {
        skills: selectedSkills,
      };

      const payload = {
        baseId,
        applicationId,
        skills: JSON.stringify(updatedSkills),
      };

      const response = await dispatch(
        UpdateJobApplicationByListForApplication(payload),
      ).unwrap();

      if (response.status === 200) {
        toast.success("Skills added successfully");

        const res = await dispatch(
          fetchApplicationByDetails({
            baseId: Number(baseId),
            jobId,
            applicationId,
          }),
        ).unwrap();

        if (res.status === 200) {
          setapplicationDetails(res?.data);
        }

        setIsSkillModalOpen(false);
      }
    } catch (error) {
      console.error("Failed to add skills:", error);
      toast.error("Failed to add skills");
    } finally {
      setIsSkillLoading(false);
    }
  };
  const parseSkills = (skills) => {
    if (!skills) return [];
    if (Array.isArray(skills)) return skills;

    try {
      // First try to parse as JSON
      const parsed = JSON.parse(skills);
      return Array.isArray(parsed) ? parsed : parsed.skills || [];
    } catch {
      // If JSON parsing fails, treat as comma-separated string
      return typeof skills === "string"
        ? skills
            .split(",")
            .map((skill) => skill.trim())
            .filter((skill) => skill.length > 0)
        : [];
    }
  };

  return (
    <>
      {!isConductReview && (
        <>
          <div className="h-screen overflow-hidden w-full">
            {/* Header */}

            <div className="  h-[calc(100vh_-_56px)] rounded-lg mt-[1px] w-full">
              <div className="flex rounded-lg h-full w-full">
                <div className="flex-1">
                  <div className="flex h-full overflow-hidden w-full">
                    {activeTab === "overview" && (
                      <>
                        {isLoadingApp ? (
                          <div className="flex items-center justify-center h-[calc(100vh_-_56px)] w-full bg-white">
                            <div className="simple-spinner-loader">
                              <span></span>
                            </div>
                          </div>
                        ) : (
                          <div className="flex-1  py-[34px] lg:py-[40px] px-0 lg:px-10 bg-white overflow-auto h-[calc(100vh_-_56px)]">
                            <div className="w-full flex justify-center h-auto">
                              <div className="w-full max-w-[640px] h-auto ">
                                {(saveAiRun?.data?.ai_summary ||
                                  applicationDetails?.application
                                    ?.ai_summary) && (
                                  <div className="bg-[#ffeab6] p-5 rounded-xl mt-0 mb-12">
                                    <div className="flex items-center gap-[6px] mb-4">
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        strokeWidth="1.5"
                                        stroke="currentColor"
                                        aria-hidden="true"
                                        data-slot="icon"
                                        className="w-4 h-4 text-[#0000007a]"
                                      >
                                        <path
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                          d="M9.813 15.904 9 18.75l-.813-2.846a4.5 4.5 0 0 0-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 0 0 3.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 0 0 3.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 0 0-3.09 3.09ZM18.259 8.715 18 9.75l-.259-1.035a3.375 3.375 0 0 0-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 0 0 2.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 0 0 2.456 2.456L21.75 6l-1.035.259a3.375 3.375 0 0 0-2.456 2.456ZM16.894 20.567 16.5 21.75l-.394-1.183a2.25 2.25 0 0 0-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 0 0 1.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 0 0 1.423 1.423l1.183.394-1.183.394a2.25 2.25 0 0 0-1.423 1.423Z"
                                        />
                                      </svg>

                                      <p className="text-[13px] leading-4 text-[#0000007a] font-medium uppercase">
                                        AI Summary
                                      </p>
                                    </div>
                                    <div className="text-[14px] text-[#000000eb] font-normal">
                                      {renderFormattedSummary(
                                        saveAiRun?.data?.ai_summary ||
                                          applicationDetails?.application
                                            ?.ai_summary,
                                      )}
                                    </div>
                                  </div>
                                )}
                                {applicationDetails?.application
                                  ?.app_summary && (
                                  <div>
                                    <div className="flex items-center mb-5 gap-x-3">
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        strokeWidth="1.5"
                                        stroke="currentColor"
                                        aria-hidden="true"
                                        data-slot="icon"
                                        className="w-4 h-4 text-dark-black-200 "
                                      >
                                        <path
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                          d="M12 21a9.004 9.004 0 0 0 8.716-6.747M12 21a9.004 9.004 0 0 1-8.716-6.747M12 21c2.485 0 4.5-4.03 4.5-9S14.485 3 12 3m0 18c-2.485 0-4.5-4.03-4.5-9S9.515 3 12 3m0 0a8.997 8.997 0 0 1 7.843 4.582M12 3a8.997 8.997 0 0 0-7.843 4.582m15.686 0A11.953 11.953 0 0 1 12 10.5c-2.998 0-5.74-1.1-7.843-2.918m15.686 0A8.959 8.959 0 0 1 21 12c0 .778-.099 1.533-.284 2.253m0 0A17.919 17.919 0 0 1 12 16.5c-3.162 0-6.133-.815-8.716-2.247m0 0A9.015 9.015 0 0 1 3 12c0-1.605.42-3.113 1.157-4.418"
                                        />
                                      </svg>
                                      <span className="font-medium text-dark-black-200  mr-1 text-[15px] flex items-center gap-[6px] ">
                                        Summary
                                      </span>
                                    </div>

                                    {
                                      applicationDetails?.application
                                        ?.app_summary
                                    }
                                  </div>
                                )}
                                {applicationDetails?.application
                                  ?.app_summary && <hr className="my-8"></hr>}

                                {applicationDetails?.application?.app_work && (
                                  <div className="mt-5">
                                    <div className="flex items-center justify-between mb-5 gap-x-3">
                                      <div className="flex items-center gap-x-3">
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width={24}
                                          height={24}
                                          viewBox="0 0 24 24"
                                          fill="none"
                                          stroke="currentColor"
                                          strokeWidth={2}
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                          className="icon icon-tabler icons-tabler-outline icon-tabler-briefcase-2 w-[1rem] h-[1rem] text-[#808080]"
                                        >
                                          <path
                                            stroke="none"
                                            d="M0 0h24v24H0z"
                                            fill="none"
                                          />
                                          <path d="M3 9a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v9a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-9z" />
                                          <path d="M8 7v-2a2 2 0 0 1 2 -2h4a2 2 0 0 1 2 2v2" />
                                        </svg>

                                        <span className="font-medium text-dark-black-200  mr-1 text-[15px] flex items-center gap-[6px] ">
                                          Experience 
                                        </span>
                                      </div>
                                      <div
                                        className="table-tooltip before:!bottom-[-32px] before:!left-[17px]"
                                        data-title="Add Experience"
                                      >
                                        <button
                                          type="button"
                                          onClick={handleAddExperience}
                                          className="relative inline-flex hover:bg-[#f4f4f5] items-center justify-center whitespace-nowrap rounded-lg text-sm
         font-medium transition-colors outline-offset-2 focus-visible:outline focus-visible:outline-2 focus-visible:outline-ring/70 disabled:pointer-events-none
          disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 border
         border-input bg-background shadow-sm shadow-black/5 hover:bg-accent hover:text-accent-foreground h-6 w-6 "
                                        >
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width={24}
                                            height={24}
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            strokeWidth={2}
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            className="icon icon-tabler icons-tabler-outline icon-tabler-plus w-[0.9rem] h-[0.9rem] text-[#808080]"
                                          >
                                            <path
                                              stroke="none"
                                              d="M0 0h24v24H0z"
                                              fill="none"
                                            />
                                            <path d="M12 5l0 14" />
                                            <path d="M5 12l14 0" />
                                          </svg>
                                        </button>
                                      </div>
                                    </div>
                                    <JobExperienceSection
                                      experienceData={
                                        applicationDetails.application.app_work
                                      }
                                      setapplicationDetails={
                                        setapplicationDetails
                                      }
                                      applicationIdByParent={applicationId}
                                    />
                                  </div>
                                )}
                                <hr className="mt-6 mb-8"></hr>
                                {applicationDetails?.application
                                  ?.app_education && (
                                  <div className="mt-5">
                                    <div className="flex items-center justify-between mb-5 gap-x-3">
                                      <div className="flex items-center gap-x-3">
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width={24}
                                          height={24}
                                          viewBox="0 0 24 24"
                                          fill="none"
                                          stroke="currentColor"
                                          strokeWidth={2}
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                          className="icon icon-tabler icons-tabler-outline icon-tabler-vocabulary w-[0.9rem] h-[0.9rem] text-[#808080]"
                                        >
                                          <path
                                            stroke="none"
                                            d="M0 0h24v24H0z"
                                            fill="none"
                                          />
                                          <path d="M10 19h-6a1 1 0 0 1 -1 -1v-14a1 1 0 0 1 1 -1h6a2 2 0 0 1 2 2a2 2 0 0 1 2 -2h6a1 1 0 0 1 1 1v14a1 1 0 0 1 -1 1h-6a2 2 0 0 0 -2 2a2 2 0 0 0 -2 -2z" />
                                          <path d="M12 5v16" />
                                          <path d="M7 7h1" />
                                          <path d="M7 11h1" />
                                          <path d="M16 7h1" />
                                          <path d="M16 11h1" />
                                          <path d="M16 15h1" />
                                        </svg>
                                        <span className="font-medium text-dark-black-200  mr-1 text-[15px] flex items-center gap-[6px] ">
                                          Education 
                                        </span>
                                      </div>
                                      <div
                                        className="table-tooltip before:!bottom-[-32px] before:!left-[17px]"
                                        data-title="Add Education"
                                      >
                                        <button
                                          type="button"
                                          onClick={handleAddEducation}
                                          className="relative inline-flex hover:bg-[#f4f4f5] items-center justify-center whitespace-nowrap rounded-lg text-sm
         font-medium transition-colors outline-offset-2 focus-visible:outline focus-visible:outline-2 focus-visible:outline-ring/70 disabled:pointer-events-none
          disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 border
         border-input bg-background shadow-sm shadow-black/5 hover:bg-accent hover:text-accent-foreground h-6 w-6 "
                                        >
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width={24}
                                            height={24}
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            strokeWidth={2}
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            className="icon icon-tabler icons-tabler-outline icon-tabler-plus w-[1rem] h-[1rem] text-[#808080]"
                                          >
                                            <path
                                              stroke="none"
                                              d="M0 0h24v24H0z"
                                              fill="none"
                                            />
                                            <path d="M12 5l0 14" />
                                            <path d="M5 12l14 0" />
                                          </svg>
                                        </button>
                                      </div>
                                    </div>

                                    <JobEducationSection
                                      educationData={
                                        applicationDetails.application
                                          .app_education
                                      }
                                      setapplicationDetails={
                                        setapplicationDetails
                                      }
                                        applicationIdByParent={applicationId}
                                    />
                                  </div>
                                )}

                                <hr className="mt-6 mb-8"></hr>
                                <div className="mb-5 gap-x-3">
                                  <div className="flex items-center justify-between">
                                    <div className="flex items-center gap-x-3">
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width={24}
                                        height={24}
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth={2}
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        className="icon icon-tabler icons-tabler-outline icon-tabler-bulb w-[1.1rem] h-[1.1rem] text-[#808080]"
                                      >
                                        <path
                                          stroke="none"
                                          d="M0 0h24v24H0z"
                                          fill="none"
                                        />
                                        <path d="M3 12h1m8 -9v1m8 8h1m-15.4 -6.4l.7 .7m12.1 -.7l-.7 .7" />
                                        <path d="M9 16a5 5 0 1 1 6 0a3.5 3.5 0 0 0 -1 3a2 2 0 0 1 -4 0a3.5 3.5 0 0 0 -1 -3" />
                                        <path d="M9.7 17l4.6 0" />
                                      </svg>

                                      <span className="font-medium text-dark-black-200  mr-1 text-[15px] flex items-center gap-[6px] ">
                                        Skills
                                      </span>
                                    </div>
                                    <div
                                      className="table-tooltip before:!bottom-[-32px] before:!left-[17px]"
                                      data-title="Add skills"
                                    >
                                      <button
                                        type="button"
                                        onClick={handleAddSkills}
                                        className="relative inline-flex hover:bg-[#f4f4f5] items-center justify-center whitespace-nowrap rounded-lg text-sm
font-medium transition-colors outline-offset-2 focus-visible:outline focus-visible:outline-2 focus-visible:outline-ring/70 disabled:pointer-events-none
disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 border
border-input bg-background shadow-sm shadow-black/5 hover:bg-accent hover:text-accent-foreground h-6 w-6 "
                                      >
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width={24}
                                          height={24}
                                          viewBox="0 0 24 24"
                                          fill="none"
                                          stroke="currentColor"
                                          strokeWidth={2}
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                          className="icon icon-tabler icons-tabler-outline icon-tabler-plus w-[0.9rem] h-[0.9rem] text-[#808080]"
                                        >
                                          <path
                                            stroke="none"
                                            d="M0 0h24v24H0z"
                                            fill="none"
                                          />
                                          <path d="M12 5l0 14" />
                                          <path d="M5 12l14 0" />
                                        </svg>
                                      </button>
                                    </div>
                                  </div>
                                  <div className="flex items-center gap-2 mt-5 flex-wrap">
                                    {parseSkills(
                                      applicationDetails.application?.skills,
                                    ).map((skill, index) => (
                                      <div
                                        key={index}
                                        className="flex items-start w-fit bg-blue-100 text-blue-800 text-sm px-2 py-1 rounded-md"
                                      >
                                        {skill.trim()}
                                      </div>
                                    ))}
                                  </div>
                                </div>
                                {/* appQuestion */}

                                {applicationResponseLoading ? (
                                  <div className="flex items-center justify-center h-[calc(50vh_-_56px)] w-full bg-white">
                                    <div className="simple-spinner-loader">
                                      <span></span>
                                    </div>
                                  </div>
                                ) : (
                                  <>
                                    {applicationResponse?.length > 0 && (
                                      <>
                                        <div className="bg-[#e0e0e0] w-full h-[1px] mt-7 mb-8"></div>

                                        <div className="flex items-center gap-x-3 mb-7">
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width={24}
                                            height={24}
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            strokeWidth={2}
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            className="icon icon-tabler icons-tabler-outline icon-tabler-library w-[1rem] h-[1rem] text-[#808080]"
                                          >
                                            <path
                                              stroke="none"
                                              d="M0 0h24v24H0z"
                                              fill="none"
                                            />
                                            <path d="M7 3m0 2.667a2.667 2.667 0 0 1 2.667 -2.667h8.666a2.667 2.667 0 0 1 2.667 2.667v8.666a2.667 2.667 0 0 1 -2.667 2.667h-8.666a2.667 2.667 0 0 1 -2.667 -2.667z" />
                                            <path d="M4.012 7.26a2.005 2.005 0 0 0 -1.012 1.737v10c0 1.1 .9 2 2 2h10c.75 0 1.158 -.385 1.5 -1" />
                                            <path d="M11 7h5" />
                                            <path d="M11 10h6" />
                                            <path d="M11 13h3" />
                                          </svg>
                                          <span className="font-medium text-dark-black-200 mr-1 text-[15px] flex items-center gap-[6px]">
                                            Application responses
                                          </span>
                                        </div>

                                        <ul className="space-y-4">
                                          {applicationResponse &&
                                            applicationResponse.map(
                                              (question, index) => (
                                                <li
                                                  key={question.id}
                                                  className="relative flex gap-x-4"
                                                >
                                                  <div className="relative flex-none w-6 h-6 rounded-full bg-gray-200 flex items-center justify-center">
                                                    <span className="text-xs font-medium text-gray-700">
                                                      {question.question_order}
                                                    </span>
                                                  </div>
                                                  <div className="flex-auto rounded-md p-4 ring-1 ring-inset ring-gray-200">
                                                    <div className="w-full flex flex-col gap-2">
                                                      <div className="flex items-center">
                                                        <div className="flex-1">
                                                          <div className="flex flex-col gap-y-1">
                                                            <div className="flex items-center gap-x-1">
                                                              <span className="font-normal text-[#374151] text-[14px] wg-antialiased leading-4">
                                                                {
                                                                  question.question_title
                                                                }
                                                              </span>
                                                            </div>
                                                            <div className="bg-gray-200 w-full h-px my-2"></div>
                                                            <div className="flex flex-col gap-1">
                                                              <span className="text-[0.8125rem] font-medium leading-4 text-[#1b1b1b] capitalize">
                                                                {question.answer ||
                                                                  "-"}
                                                              </span>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </li>
                                              ),
                                            )}
                                        </ul>
                                      </>
                                    )}
                                  </>
                                )}
                              </div>
                            </div>
                          </div>
                        )}
                      </>
                    )}

                    {activeTab === "resume" && (
                      <div className="flex-1 flex flex-col bg-white h-full py-[34px] lg:py-[40px] px-0 lg:px-10 overflow-auto">
                        <div className="w-full">
                          <div className="w-full">
                            <JobResumeSection
                              resumeData={
                                applicationDetails?.application?.app_resume
                              }
                              sidebarOpen={sidebarOpen}
                              quickData={quickData?.id}
                              fromResumeTab={true}
                            />
                          </div>
                        </div>
                      </div>
                    )}

                    {/* message  */}

                    {activeTab === "message" && (
                      <div className="flex-1 flex flex-col bg-white h-full py-[34px] lg:py-[40px] px-0 lg:px-10 overflow-auto">
                        <div className="w-full flex justify-center">
                          <div className="w-full max-w-[640px]">
                            <h2 className="text-[18px] lg:text-[18px] font-medium leading-5 text-[#1b1b1b] tracking-[-0.01rem] capitalize mb-5">
                              Messages
                            </h2>
                            <div className="bg-[#e0e0e0] w-full h-[1px] mt-4 mb-8"></div>
                            <JobMessageSection quickData={quickData?.id} />
                          </div>
                        </div>
                      </div>
                    )}

                    {activeTab === "team-discussion" && (
                      <div className="flex-1 flex flex-col bg-white h-full py-[34px] lg:py-[40px] px-0 lg:px-10 overflow-auto">
                        <div className=" w-full flex justify-center">
                          <div className="w-full max-w-[640px]">
                            <h2 className="text-[18px] lg:text-[18px] font-medium leading-5 text-[#1b1b1b] tracking-[-0.01rem] capitalize mb-5">
                             Teams
                            </h2>
                            <div className="bg-[#e0e0e0] w-full h-[1px] mt-4 mb-8"></div>
                            <JobTeamDiscussion quickData={quickData?.id} />
                          </div>
                        </div>
                      </div>
                    )}

                    {activeTab === "notes" && (
                      <div className="flex-1 flex bg-white flex-col h-full py-[34px] lg:py-[40px] px-0 lg:px-10 overflow-auto">
                        <div className="w-full flex justify-center">
                          <div className="w-full max-w-[640px]">
                            <h2 className="text-[18px] lg:text-[18px] font-medium leading-5 text-[#1b1b1b] tracking-[-0.01rem] capitalize mb-5">
                              Notes
                            </h2>
                            <div className="bg-[#e0e0e0] w-full h-[1px] mt-4 mb-8"></div>
                            <JobNotesSection quickData={quickData?.id} />
                          </div>
                        </div>
                      </div>
                    )}

                    {activeTab === "files" && (
                      <div className="flex-1 flex bg-white flex-col h-full py-[34px] lg:py-[40px] px-0 lg:px-10 overflow-auto">
                        <div className=" w-full flex justify-center">
                          <div className="w-full max-w-[640px]">
                            <h2 className="text-[18px] lg:text-[18px] font-medium leading-5 text-[#1b1b1b] tracking-[-0.01rem] capitalize mb-5">
                              Files
                            </h2>
                            <div className="bg-[#e0e0e0] w-full h-[1px] mt-4 mb-8"></div>
                            <JobFilesSection quickData={quickData?.id} />
                          </div>
                        </div>
                      </div>
                    )}

                    {activeTab === "scorecards" && !skillId && (
                      <div className="flex-1 flex flex-col bg-white h-full py-[34px] lg:py-[40px] px-0 lg:px-10 overflow-auto">
                        <div className="w-full flex justify-center">
                          <div className="w-full max-w-[640px]">
                            <h2 className="text-[18px] lg:text-[18px] font-medium leading-5 text-[#1b1b1b] tracking-[-0.01rem] capitalize mb-5">
                              Scorecards
                            </h2>
                            <div className="bg-[#e0e0e0] w-full h-[1px] mt-6 mb-6"></div>
                            <JobScorecardsSection quickData={quickData?.id} />
                          </div>
                        </div>
                      </div>
                    )}

                    {skillId && (
                      <div className="flex-1 flex flex-col bg-white h-full py-[34px] lg:py-[40px] px-0 lg:px-10 overflow-auto">
                        <div className="w-full flex justify-center">
                          <div className="w-full max-w-[640px]">
                            <h2 className="text-[18px] lg:text-[18px] font-medium leading-5 text-[#1b1b1b] tracking-[-0.01rem] capitalize mb-5">
                              Scorecards
                            </h2>
                            <div className="bg-[#e0e0e0] w-full h-[1px] mt-4 mb-4"></div>
                            {isEditMode ? (
                              <JobSkillScorecardEdit
                                skillId={skillId}
                                quickData={quickData?.id}
                              />
                            ) : (
                              <JobSkillScorecard
                                skillId={skillId}
                                quickData={quickData?.id}
                              />
                            )}
                          </div>
                        </div>
                      </div>
                    )}

                    {/* {activeTab === 'questionnaire' && !QuestionsId &&
                        <div className="flex-1 flex flex-col bg-white h-full py-[34px] lg:py-[40px] px-0 lg:px-10 overflow-auto">
                          <div className=' w-full flex justify-center'>
                            <div className='w-full max-w-[640px]'>
                              <h2 className="text-[18px] lg:text-[18px] font-medium leading-5 text-[#1b1b1b] tracking-[-0.01rem] capitalize mb-5">questionnaire</h2>
                              <div className='bg-[#e0e0e0] w-full h-[1px] mt-6 mb-6'></div>
                              <ApplicationQuestionnaireSection quickData={quickData?.id} onQuestionnaireAction={handleQuestionnaireAction} />
                            </div>
                          </div>
                        </div>
                      }

                      {QuestionsId && (
                        <div className="flex-1 flex flex-col bg-white h-full py-[34px] lg:py-[40px] px-0 lg:px-10 overflow-auto">
                          <div className='w-full flex justify-center'>
                            <div className='w-full max-w-[640px]'>
                              <Link
                                to={`/${baseId}/job/${jobId}/app/${applicationId}/questionnaire`}
                                className='flex items-center gap-x-1 w-full mb-4 ml-[-4px]'
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width={24}
                                  height={24}
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  strokeWidth={2}
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  className="icon icon-tabler icons-tabler-outline icon-tabler-chevron-left w-[0.9rem] h-[0.9rem]"
                                >
                                  <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                  <path d="M15 6l-6 6l6 6" />
                                </svg>
                                <span className='text-black-100 text-[13px]'>
                                  Back to Questionnaire
                                </span>
                              </Link>
                              <QuestionSetDetails QuestionsId={QuestionsId} quickData={quickData?.id} />
                            </div>
                          </div>
                        </div>
                      )} */}

                    {activeTab === "questionnaire" && !QuestionsId && (
                      <div className="flex-1 flex flex-col bg-white h-full py-[34px] lg:py-[40px] px-0 lg:px-10 overflow-auto">
                        <div className="w-full flex justify-center">
                          <div className="w-full max-w-[640px]">
                            <h2 className="text-[18px] lg:text-[18px] font-medium leading-5 text-[#1b1b1b] tracking-[-0.01rem] capitalize mb-5">
                              questionnaire
                            </h2>
                            <div className="bg-[#e0e0e0] w-full h-[1px] mt-6 mb-6"></div>

                            {showQuestionnaireDetails ? (
                              <>
                                <div className="flex items-center gap-x-1 w-full mb-4 ml-[-4px]">
                                  <button
                                    onClick={() =>
                                      setShowQuestionnaireDetails(false)
                                    }
                                    className="flex items-center gap-x-1"
                                  >
                                    <BackIcon className="h-4 w-4" />
                                    <span className="text-black-100 text-[13px]">
                                      Back to Questionnaire
                                    </span>
                                  </button>
                                </div>
                                <QuestionSetDetails
                                  QuestionsId={currentQuestionnaireId}
                                  quickData={quickData?.id}
                                />
                              </>
                            ) : (
                              <ApplicationQuestionnaireSection
                                quickData={quickData?.id}
                                onQuestionnaireAction={
                                  handleQuestionnaireAction
                                }
                              />
                            )}
                          </div>
                        </div>
                      </div>
                    )}

                    {activeTab === "meetings" && !meetingId && (
                      <div className="flex-1 flex flex-col bg-white h-full py-[34px] lg:py-[40px] px-0 lg:px-10 overflow-auto">
                        <div className="w-full flex justify-center">
                          <div className="w-full max-w-[640px]">
                            {/* <div className='bg-[#e0e0e0] w-full h-[1px] mt-6 mb-6'></div> */}

                            {showMeetingDetails ? (
                              <>
                                <div className="flex items-center gap-x-1 w-full mb-4 ml-[-4px]">
                                  <button
                                    onClick={() => setShowMeetingDetails(false)}
                                    className="flex items-center gap-x-1"
                                  >
                                    <BackIcon className="h-4 w-4" />
                                    <span className="text-black-100 text-[13px]">
                                      Back to Meetings
                                    </span>
                                  </button>
                                </div>
                                <MeetingDetails
                                  meetingId={meetingId}
                                  quickData={quickData?.id}
                                  currentMeetingId={currentMeetingId}
                                />
                              </>
                            ) : (
                              <MeetingSection
                                applicationDetails={
                                  applicationDetails.application
                                }
                                quickData={quickData?.id}
                                onQuestionnaireAction={handleMeetingsAction}
                              />
                            )}
                          </div>
                        </div>
                      </div>
                    )}

                    {/* {activeTab === 'meetings' && !meetingId &&
                        <div className="flex-1 flex flex-col bg-white h-full py-[34px] lg:py-[40px] px-0 lg:px-10 overflow-auto">
                          <div className=' w-full flex justify-center'>
                            <div className='w-full max-w-[640px]'>
                              <MeetingSection applicationDetails={applicationDetails.application} quickData={quickData?.id} />
                            </div>
                          </div>
                        </div>
                      }

                      {
                        meetingId &&
                        <div className="flex-1 flex flex-col bg-white  h-full py-[34px] lg:py-[40px] px-0 lg:px-10 overflow-auto">
                          <div className=' w-full flex justify-center'>
                            <div className='w-full max-w-[640px]'>
                              <Link
                                to={`/${baseId}/job/${jobId}/app/${applicationId}/meetings`}
                                className='flex items-center gap-x-1 w-full mb-4 ml-[-4px]'
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width={24}
                                  height={24}
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  strokeWidth={2}
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  className="icon icon-tabler icons-tabler-outline icon-tabler-chevron-left w-[0.9rem] h-[0.9rem]"
                                >
                                  <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                  <path d="M15 6l-6 6l6 6" />
                                </svg>
                                <span className='text-black-100 text-[13px]'>
                                  Back to Meeting
                                </span>
                              </Link>
                              <MeetingDetails meetingId={meetingId} quickData={quickData?.id} />
                            </div>
                          </div>
                        </div>
                      } */}

                    {activeTab === "app-review" && !appreviewId && (
                      <div className="flex-1 flex flex-col bg-white h-full py-[34px] lg:py-[40px] px-0 lg:px-10 overflow-auto">
                        <div className="w-full flex justify-center">
                          <div className="w-full max-w-[640px]">
                            {/* <div className='bg-[#e0e0e0] w-full h-[1px] mt-6 mb-6'></div> */}

                            {showAppReviewDetails ? (
                              <>
                                <div className="flex items-center gap-x-1 w-full mb-4 ml-[-4px]">
                                  <button
                                    onClick={() =>
                                      setShowAppReviewDetails(false)
                                    }
                                    className="flex items-center gap-x-1"
                                  >
                                    <BackIcon className="h-4 w-4" />
                                    <span className="text-black-100 text-[13px]">
                                      Back to App Review
                                    </span>
                                  </button>
                                </div>
                                <AppReviewDetails
                                  meetingId={appreviewId}
                                  setConductReview={setConductReview}
                                  conductReview={conductReview}
                                  quickData={quickData?.id}
                                  currentAppReviewId={currentAppReviewId}
                                />
                              </>
                            ) : (
                              <AppReviewSection
                                applicationDetails={
                                  applicationDetails.application
                                }
                                quickData={quickData?.id}
                                onQuestionnaireAction={handleAppReviewAction}
                              />
                            )}
                          </div>
                        </div>
                      </div>
                    )}

                    {/* {activeTab === 'app-review' && !appreviewId &&
                        <div className="flex-1 flex flex-col bg-white  h-full py-[34px] lg:py-[40px] px-0 lg:px-10 overflow-auto">
                          <div className=' w-full flex justify-center'>
                            <div className='w-full max-w-[640px]'>
                              <AppReviewSection applicationDetails={applicationDetails.application} quickData={quickData?.id} />
                            </div>
                          </div>
                        </div>
                      }

                      {
                        appreviewId &&
                        <div className="flex-1 flex flex-col bg-white h-full py-[34px] lg:py-[40px] px-0 lg:px-10 overflow-auto">
                          <div className=' w-full flex justify-center'>
                            <div className='w-full max-w-[640px]'>
                              <Link
                                to={`/${baseId}/job/${jobId}/app/${applicationId}/appreview`}
                                className='flex items-center gap-x-1 w-full mb-4 ml-[-4px]'
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width={24}
                                  height={24}
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  strokeWidth={2}
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  className="icon icon-tabler icons-tabler-outline icon-tabler-chevron-left w-[0.9rem] h-[0.9rem]"
                                >
                                  <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                  <path d="M15 6l-6 6l6 6" />
                                </svg>
                                <span className='text-black-100 text-[13px]'>
                                  Back to App Review
                                </span>
                              </Link>
                              <AppReviewDetails meetingId={appreviewId} setConductReview={setConductReview} conductReview={conductReview} quickData={quickData?.id} />
                            </div>
                          </div>
                        </div>
                      } */}

                    {activeTab === "journey" && (
                      <div className="flex-1 flex flex-col bg-white h-full py-[34px] lg:py-[40px] px-0 lg:px-10 overflow-auto">
                        <div className=" w-full flex justify-center">
                          <div className="w-full max-w-[640px]">
                            <h2 className="text-[18px] lg:text-[18px] font-medium leading-5 text-[#1b1b1b] tracking-[-0.01rem] capitalize mb-5">
                              {" "}
                              App Journey
                            </h2>
                            <div className="bg-[#e0e0e0] w-full h-[1px] mt-4 mb-8"></div>
                            <Journey quickData={quickData?.id} />
                          </div>
                        </div>
                      </div>
                    )}
                    <div
                      className={`max-w-[50px] w-full border-l border-gray-200 pt-0 bg-white ${
                        sidebarOpen
                          ? "rounded-tl-lg rounded-bl-lg"
                          : "rounded-tl-none rounded-bl-none"
                      }`}
                    >
                      <ul role="list" className="mx-2">
                        {/* <div className="flex items-center mx-2 gap-2 py-5 ">

                          </div> */}

                        {navItems.map((item) => {
                          // const isActive = location.pathname === item.to || location.pathname.endsWith(item.name.toLowerCase().replace(" ", "-"));
                          const isActive =
                            activeTab ===
                            item.name.toLowerCase().replace(" ", "-");

                          return (
                            <li
                              key={item.name}
                              data-title={item.name}
                              className={cn(
                                "table-tooltip-list before:!bottom-[3px] before:!left-[-36px] before:!text-[12px] h-[32px] first:mt-[1rem] mb-[2px] py-[2px] sidebar-nav",
                                item.name === "Files" && "before:!left-[-25px]",
                                item.name === "Notes" && "before:!left-[-27px]",
                                item.name === "Team Discussion" &&
                                  "before:!left-[-57px]",
                                item.name === "ScoreCards" &&
                                  "before:!left-[-45px]",
                                item.name === "Questionnaire" &&
                                  "before:!left-[-50px]",
                                item.name === "App Review" &&
                                  "before:!left-[-45px]",
                              )}
                            >
                              <button
                                onClick={handleChangeView}
                                className={classNames(
                                  isActive
                                    ? "text-black-100 bg-gray-200 hover:bg-gray-300"
                                    : "text-black-100 hover:text-black-100 hover:bg-gray-100",
                                  "group flex gap-x-[10px] p-0 text-[13px] mx-0 min-h-[32px] w-full cursor-pointer leading-5 items-center rounded-[0.375rem] font-medium text-wedges-gray-900 focus:outline-none px-2",
                                )}
                              >
                                <item.icon
                                  aria-hidden="true"
                                  className={classNames(
                                    isActive
                                      ? "text-[#0000007a]"
                                      : "text-[#0000007a] group-hover:text-black-100",
                                    "h-[1.1em] w-[1.1em] shrink-0",
                                  )}
                                />
                              </button>
                            </li>
                          );
                        })}
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* experience  */}
          <Dialog
            open={isModalOpen}
            onClose={setIsModalOpen}
            className="relative z-10"
          >
            <DialogBackdrop
              transition
              className="fixed inset-0 bg-gray-500/75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
            />

            <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
              <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                <DialogPanel
                  transition
                  className="relative transform rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-lg sm:p-6 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
                >
                  <h3 className="text-base font-semibold leading-6 text-gray-900">
                    Add New Experience
                  </h3>
                  <div className="absolute right-0 top-0 hidden pr-4 pt-4 sm:block">
                    <button
                      type="button"
                      onClick={() => setIsModalOpen(false)}
                      className="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                    >
                      <span className="sr-only">Close</span>
                      <CrossIcon aria-hidden="true" className="size-6" />
                    </button>
                  </div>
                  <div className="grid gap-4 py-4 mt-1">
                    <div className="grid gap-[6px]">
                      <label className="wg-label inline-flex shrink-0 items-center gap-1 text-[14px] text-[#2f2f31] wg-antialiased leading-5">
                        Company <span className="text-red-500">*</span>
                      </label>
                      <input
                        name="company"
                        value={newExperienceForm.company}
                        onChange={handleInputChange}
                        className="flex grow rounded-lg border bg-background px-4 py-[5px] text-sm leading-6 shadow-wg-xs transition-colors duration-100 placeholder:text-surface-500 outline-primary focus:outline focus:outline-1 focus:-outline-offset-1 w-full text-surface-900 hover:border-surface-300 dark:hover:border-surface-200 border-surface-200 dark:border-surface-100 focus:outline-indigo-600 border-[#e5e7eb]"
                      />
                    </div>
                    <div className="grid gap-[6px]">
                      <label className="wg-label inline-flex shrink-0 items-center gap-1 text-[14px] text-[#2f2f31] wg-antialiased leading-5">
                        Designation <span className="text-red-500">*</span>
                      </label>
                      <input
                        name="designation"
                        value={newExperienceForm.designation}
                        onChange={handleInputChange}
                        className="flex grow rounded-lg border bg-background px-4 py-[5px] text-sm leading-6 shadow-wg-xs transition-colors duration-100 placeholder:text-surface-500 outline-primary focus:outline focus:outline-1 focus:-outline-offset-1 w-full text-surface-900 hover:border-surface-300 dark:hover:border-surface-200 border-surface-200 dark:border-surface-100 focus:outline-indigo-600 border-[#e5e7eb]"
                      />
                    </div>
                    <div className="grid grid-cols-2 gap-4">
                      <CustomDropdown
                        label="Start Month"
                        value={newExperienceForm.startDateMonth}
                        onChange={handleInputChange}
                        options={months}
                        name="startDateMonth"
                      />
                      <CustomDropdown
                        label="Start Year"
                        value={newExperienceForm.startDateYear}
                        onChange={handleInputChange}
                        options={years}
                        name="startDateYear"
                      />
                    </div>
                    <div className="grid gap-[6px] mt-[-10px]">
                      <label className="wg-label inline-flex shrink-0 items-center gap-1 text-[14px] text-[#2f2f31] wg-antialiased leading-5 w-[100px]">
                        <input
                          type="checkbox"
                          name="isCurrentJob"
                          checked={newExperienceForm.isCurrentJob}
                          onChange={handleInputChange}
                          className="col-start-1 row-start-1 appearance-none rounded border border-gray-300 bg-white checked:border-indigo-600 checked:bg-indigo-600 indeterminate:border-indigo-600 indeterminate:bg-indigo-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 disabled:border-gray-300 disabled:bg-gray-100 disabled:checked:bg-gray-100 forced-colors:appearance-auto"
                        />
                        Current Job
                      </label>
                    </div>

                    {!newExperienceForm.isCurrentJob && (
                      <div className="grid grid-cols-2 gap-4">
                        <CustomDropdown
                          label="End Month"
                          value={newExperienceForm.endDateMonth}
                          onChange={handleInputChange}
                          options={months}
                          name="endDateMonth"
                        />
                        <CustomDropdown
                          label="End Year"
                          value={newExperienceForm.endDateYear}
                          onChange={handleInputChange}
                          options={years}
                          name="endDateYear"
                        />
                      </div>
                    )}
                    <JobWorkplaceTypeListbox
                      value={workplaceType}
                      onChange={handleWorkplaceTypeChange}
                    />
                    <div className="grid gap-[6px]">
                      <label className="wg-label inline-flex shrink-0 items-center gap-1 text-[14px] text-[#2f2f31] wg-antialiased leading-5">
                        Location
                      </label>
                      <JobEduLocationModal
                        items={locations}
                        buttonText="Search by city, state, or country"
                        onChange={handleLocationChange}
                        selectedItem={selectedCountry}
                        isLoading={loadingLocation}
                      />
                    </div>
                    <div className="grid gap-[6px]">
                      <label className="wg-label inline-flex shrink-0 items-center gap-1 text-[14px] text-[#2f2f31] wg-antialiased leading-5">
                        Description
                      </label>
                      <textarea
                        id="description"
                        name="description"
                        rows={4}
                        onChange={handleInputChange}
                        className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
                        value={newExperienceForm.description}
                      />
                    </div>
                  </div>

                  <div className="flex justify-end gap-4 mt-5">
                    <button
                      className="rounded-md bg-white items-center px-[14px] py-1 text-[13px] font-medium h-[32px] text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
                      onClick={() => setIsModalOpen(false)}
                    >
                      Cancel
                    </button>
                    <button
                      onClick={handleSubmit}
                      className="rounded-md bg-indigo-600 items-center px-[14px] py-1 text-[13px] font-medium h-[32px] text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                    >
                      <div className="flex items-center gap-[6px]">
                        Save
                        {isLoading && (
                          <div className="simple-spinner">
                            <span></span>
                          </div>
                        )}
                      </div>
                    </button>
                  </div>
                </DialogPanel>
              </div>
            </div>
          </Dialog>

          {/* education  */}

          <Dialog
            open={isModalOpenEdu}
            onClose={setIsModalOpenEdu}
            className="relative z-10"
          >
            <DialogBackdrop
              transition
              className="fixed inset-0 bg-gray-500/75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
            />

            <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
              <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                <DialogPanel
                  transition
                  className="relative transform rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-lg sm:p-6 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
                >
                  <h3 className="text-base font-semibold leading-6 text-gray-900">
                    Add New Education
                  </h3>
                  <div className="absolute right-0 top-0 hidden pr-4 pt-4 sm:block">
                    <button
                      type="button"
                      onClick={() => setIsModalOpenEdu(false)}
                      className="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                    >
                      <span className="sr-only">Close</span>
                      <CrossIcon aria-hidden="true" className="size-6" />
                    </button>
                  </div>
                  <div className="grid gap-4 py-4 mt-1">
                    <div className="grid gap-[6px]">
                      <label
                        htmlFor="course"
                        className="wg-label inline-flex shrink-0 items-center gap-1 text-[14px] text-[#2f2f31] wg-antialiased  leading-5"
                      >
                        Course
                      </label>
                      <input
                        id="course"
                        name="course"
                        value={newEducationForm?.course}
                        onChange={handleInputChangeEducation}
                        className="flex grow rounded-lg border bg-background px-4 py-[5px] text-sm leading-6 shadow-wg-xs transition-colors
                    duration-100 placeholder:text-surface-500 outline-primary focus:outline focus:outline-1 focus:-outline-offset-1 w-full text-surface-900 hover:border-surface-300 
                   dark:hover:border-surface-200 border-surface-200 dark:border-surface-100 focus:outline-indigo-600 border-[#e5e7eb]"
                      />
                    </div>
                    <div className="grid gap-[6px]">
                      <label
                        htmlFor="course"
                        className="wg-label inline-flex shrink-0 items-center gap-1 text-[14px] text-[#2f2f31] wg-antialiased  leading-5"
                      >
                        University
                      </label>
                      <input
                        id="university"
                        name="university"
                        value={newEducationForm?.university}
                        onChange={handleInputChangeEducation}
                        className="flex grow rounded-lg border bg-background px-4 py-[5px] text-sm leading-6 shadow-wg-xs transition-colors
                    duration-100 placeholder:text-surface-500 outline-primary focus:outline focus:outline-1 focus:-outline-offset-1 w-full text-surface-900 hover:border-surface-300 
                   dark:hover:border-surface-200 border-surface-200 dark:border-surface-100 focus:outline-indigo-600 border-[#e5e7eb]"
                      />
                    </div>
                    <div className="grid grid-cols-2 gap-4">
                      <div className="grid gap-[6px]">
                        <label className="wg-label inline-flex shrink-0 items-center gap-1 text-[14px] text-[#2f2f31] wg-antialiased leading-5">
                          Start Date
                        </label>
                        <div className="grid grid-cols-2 gap-2">
                          <CustomDropdown
                            value={newEducationForm.start_month}
                            onChange={handleInputChangeEducation}
                            options={months}
                            name="start_month"
                            placeholder="Month"
                          />
                          <CustomDropdown
                            value={newEducationForm.start_year}
                            onChange={handleInputChangeEducation}
                            options={years}
                            name="start_year"
                            placeholder="Year"
                          />
                        </div>
                      </div>
                      <div className="grid gap-[6px]">
                        <label className="wg-label inline-flex shrink-0 items-center gap-1 text-[14px] text-[#2f2f31] wg-antialiased leading-5">
                          End Date
                        </label>
                        <div className="grid grid-cols-2 gap-2">
                          <CustomDropdown
                            value={newEducationForm.end_month}
                            onChange={handleInputChangeEducation}
                            options={months}
                            name="end_month"
                            placeholder="Month"
                          />
                          <CustomDropdown
                            value={newEducationForm.end_year}
                            onChange={handleInputChangeEducation}
                            options={years}
                            name="end_year"
                            placeholder="Year"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="grid gap-[6px]">
                      <label
                        htmlFor="course"
                        className="wg-label inline-flex shrink-0 items-center gap-1 text-[14px] text-[#2f2f31] wg-antialiased  leading-5"
                      >
                        Location
                      </label>
                      <JobEduLocationModal
                        items={locations}
                        buttonText="Search by city, state, or country"
                        onChange={handleLocationChangeEdu}
                        selectedItem={selectedCountryEdu}
                        isLoading={loadingLocationEdu}
                      />
                    </div>
                    <div className="grid gap-[6px]">
                      <label
                        htmlFor="course"
                        className="wg-label inline-flex shrink-0 items-center gap-1 text-[14px] text-[#2f2f31] wg-antialiased  leading-5"
                      >
                        Specialization
                      </label>
                      <input
                        id="branch"
                        name="branch"
                        value={newEducationForm?.branch}
                        onChange={handleInputChangeEducation}
                        className="flex grow rounded-lg border bg-background px-4 py-[5px] text-sm leading-6 shadow-wg-xs transition-colors
                    duration-100 placeholder:text-surface-500 outline-primary focus:outline focus:outline-1 focus:-outline-offset-1 w-full text-surface-900 hover:border-surface-300 
                   dark:hover:border-surface-200 border-surface-200 dark:border-surface-100 focus:outline-indigo-600 border-[#e5e7eb]"
                      />
                    </div>
                    <div className="grid gap-[6px]">
                      <label
                        htmlFor="course"
                        className="wg-label inline-flex shrink-0 items-center gap-1 text-[14px] text-[#2f2f31] wg-antialiased  leading-5"
                      >
                        Grade
                      </label>
                      <input
                        id="grade"
                        name="grade"
                        type="text"
                        value={newEducationForm.grade}
                        onChange={handleInputChangeEducation}
                        className="flex grow rounded-lg border bg-background px-4 py-[5px] text-sm leading-6 shadow-wg-xs transition-colors
                     duration-100 placeholder:text-surface-500 outline-primary focus:outline focus:outline-1 focus:-outline-offset-1 w-full text-surface-900 hover:border-surface-300 
                    dark:hover:border-surface-200 border-surface-200 dark:border-surface-100 focus:outline-indigo-600 border-[#e5e7eb]"
                      />
                    </div>
                    <div className="grid gap-[6px]">
                      <label
                        htmlFor="description"
                        className="wg-label inline-flex shrink-0 items-center gap-1 text-[14px] text-[#2f2f31] wg-antialiased  leading-5"
                      >
                        Description
                      </label>
                      <textarea
                        id="description"
                        name="description"
                        rows={4}
                        value={newEducationForm?.description}
                        onChange={handleInputChangeEducation}
                        className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
                      />
                    </div>
                  </div>

                  <div className="flex justify-end gap-4 mt-5">
                    <button
                      className="rounded-md bg-white items-center px-[14px] py-1 text-[13px] font-medium h-[32px] text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
                      onClick={() => setIsModalOpenEdu(false)}
                    >
                      Cancel
                    </button>
                    <button
                      onClick={handleSubmitEdution}
                      className="rounded-md bg-indigo-600 items-center px-[14px] py-1 text-[13px] font-medium h-[32px] text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                    >
                      <div className="flex items-center gap-[6px]">
                        Save
                        {isLoadingEdu && (
                          <div className="simple-spinner">
                            <span></span>
                          </div>
                        )}
                      </div>
                    </button>
                  </div>
                </DialogPanel>
              </div>
            </div>
          </Dialog>

          {/* skills */}
          <Dialog
            open={isSkillModalOpen}
            onClose={setIsSkillModalOpen}
            className="relative z-10"
          >
            <DialogBackdrop
              transition
              className="fixed inset-0 bg-gray-500/75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
            />

            <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
              <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                <DialogPanel
                  transition
                  className="relative transform rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-lg sm:p-6 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
                >
                  <h3 className="text-base font-semibold leading-6 text-gray-900">
                    Add New Skills
                  </h3>
                  <div className="absolute right-0 top-0 hidden pr-4 pt-4 sm:block">
                    <button
                      type="button"
                      onClick={() => setIsSkillModalOpen(false)}
                      className="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                    >
                      <span className="sr-only">Close</span>
                      <CrossIcon aria-hidden="true" className="size-6" />
                    </button>
                  </div>
                  <div className="space-y-2 md:space-y-4 lg:space-y-4">
                    <SkillsInput
                      value={selectedSkills}
                      onChange={setSelectedSkills}
                    />
                  </div>

                  <div className="flex justify-end gap-2 mt-5">
                    <button
                      className="rounded-md bg-white items-center px-[14px] py-1 text-[13px] font-medium h-[32px] text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
                      onClick={() => setIsSkillModalOpen(false)}
                    >
                      Cancel
                    </button>
                    <button
                      onClick={handleSubmitSkills}
                      className="rounded-md bg-indigo-600 items-center px-[14px] py-1 text-[13px] font-medium h-[32px] text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                    >
                      <div className="flex items-center gap-[6px]">
                        Save
                        {isSkillLoading && (
                          <div className="simple-spinner">
                            <span></span>
                          </div>
                        )}
                      </div>
                    </button>
                  </div>
                </DialogPanel>
              </div>
            </div>
          </Dialog>
        </>
      )}
      {isConductReview && (
        <CandidateReviewLayout
          isOpenHeader={isOpenHeader}
          setIsOpenHeader={setIsOpenHeader}
          selectedFilterHeader={selectedFilterHeader}
          setSelectedFilterHeader={setSelectedFilterHeader}
          optionsWithAllStagesHeader={optionsWithAllStagesHeader}
          applicationDetails={applicationDetails}
          setapplicationDetails={setapplicationDetails}
          isConductReview={isConductReview}
          appreviewId={appreviewId}
          appreviewId1={appreviewId1}
          QuestionsId={appreviewId1}
        />
      )}
    </>
  );
};

export default QuickViewResponse;
